import { PRODUCT_AREA, usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { ANALYTICS_SCREEN_NAMES } from '@telus-alberta-health-web/shared-module';
import { MASONRY } from 'common/constants';
import { PageContentWrapper } from 'components/page-content-wrapper.component';
import { PageHeader } from 'components/page-header/page-header.component';

export const BrowseHealthTopics = () => {
  usePageViewAnalytics({
    product_area: PRODUCT_AREA.ONBOARDING,
    screen_name: ANALYTICS_SCREEN_NAMES.BROWSE_HEALTH_TOPICS,
  });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_HEALTH_TOPICS_PAGE_HEADING' }));

  return (
    <PageContentWrapper>
      <PageHeader
        headingText={formatMessage({
          id: 'STR_HEALTH_TOPICS_PAGE_HEADING',
        })}
      />
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_HEALTH_TOPICS} />
    </PageContentWrapper>
  );
};
